import React from 'react'
import Translation from '../global/Translation'

/**
 * Diccionario de traducciones de cadenas de SearchKit (`sk.translateFunction`).
 *
 * SearchKit lo usa tanto para las cadenas propias (paginación, "ver más"...) como para traducir el
 * valor de los filtros seleccionados: el label que se ve en el tag (p. ej. `Finish: MAT` → `Matte`)
 * sale de aquí. Vive en un módulo aparte para poder compartirlo entre el catálogo (`Catalog.js`) y la
 * landing de campañas (`PromotionProductsSearch.js`) sin duplicarlo.
 *
 * Salió tal cual del `translateFunction` de Catalog.js. Contiene claves que solo aplican al catálogo
 * (tipos de Mktools, etc.); en la landing simplemente no se usan.
 */
export const getSearchkitTranslations = () => ({
    'pagination.previous': <Translation id="previous" defaultMessage="Previous" />,
    'pagination.next': <Translation id="next" defaultMessage="Next" />,
    'facets.view_more': <Translation id="view_more" defaultMessage="View more" />,
    'facets.view_less': <Translation id="view_less" defaultMessage="View less" />,
    'facets.view_all': <Translation id="view_all" defaultMessage="View all" />,
    'reset.clear_all': <Translation id="clear_all" defaultMessage="Clear all" />,
    'yes': <Translation id="yes" defaultMessage="Yes" />,
    'no': <Translation id="no" defaultMessage="No" />,
    'outlet_o': <Translation id="outlet_o" defaultMessage="Outlet Basic" />,
    'outlet_v': <Translation id="outlet_v" defaultMessage="Outlet Premium" />,
    'outlet_x': <Translation id="outlet_x" defaultMessage="Outlet Xtreme" />,
    'outlet_w': <Translation id="outlet_w" defaultMessage="Outlet Premium Plus" />,
    'AND': <Translation id="AND" defaultMessage="Grip +" />,
    'MAT': <Translation id="MAT" defaultMessage="Matte" />,
    'MTT': <Translation id="MTT" defaultMessage="Texturized matte" />,
    'PUL': <Translation id="PUL" defaultMessage="Polished" />,
    'PULMAL': <Translation id="PULMAL" defaultMessage="Polished - meshed" />,
    'PUA': <Translation id="PUA" defaultMessage="Mirage - glase" />,
    'PUC': <Translation id="PUC" defaultMessage="Mirage - century" />,
    'PUN': <Translation id="PUN" defaultMessage="Polished - n-boost" />,
    'MK': <Translation id="mktool" defaultMessage="Marketing Tools" />,
    'SH': <Translation id="showroom" defaultMessage="Showroom" />,
    'WH': <Translation id="warehouse" defaultMessage="Warehouse" />,
    'OPERATIONS': <Translation id="OPERATIONS" defaultMessage="Operations" />,
    'SERVICE': <Translation id="SERVICE" defaultMessage="Services" />,
    '01': <Translation id="SAMPLES" defaultMessage="Samples" />,
    '02': <Translation id="OTHERS" defaultMessage="Others" />,
    '03': <Translation id="MERCHANDISING" defaultMessage="Merchandising" />,
    '04': <Translation id="LITERATURE" defaultMessage="Literature" />,
    '05': <Translation id="TAGS" defaultMessage="Tags" />,
    '06': <Translation id="ANCHORING" defaultMessage="anchoring" />,
    '07': <Translation id="BOXES" defaultMessage="Boxes" />,
    '08': <Translation id="DISPLAYS" defaultMessage="Displays" />,
    '09': <Translation id="BOOKS" defaultMessage="Books" />,
    '10': <Translation id="CABINETS" defaultMessage="Cabinets" />,
    '11': <Translation id="SIGNAGE" defaultMessage="Signage" />,
    '12': <Translation id="TEST_KITS" defaultMessage="Test kits" />,
    '13': <Translation id="WORKWEAR" defaultMessage="Workwear" />,
    '14': <Translation id="EPP" defaultMessage="EPP" />,
    '15': <Translation id="WAREHOUSE_SUPPLIES" defaultMessage="warehouse supplies" />,
    'NEWS': <Translation id="NEWS" defaultMessage="NEWS" />,
    'without_format': <Translation id="without_format" defaultMessage="Without format" />,
    'white': <Translation id="white" defaultMessage="White" />,
    'black': <Translation id="black" defaultMessage="Black" />,
    'grey': <Translation id="grey" defaultMessage="Grey" />,
    'cream': <Translation id="cream" defaultMessage="Cream" />,
    'brown': <Translation id="brown" defaultMessage="Brown" />,
    'other': <Translation id="other" defaultMessage="Other" />,
    'blue': <Translation id="blue" defaultMessage="Blue" />,
    'green': <Translation id="green" defaultMessage="Green" />,
    'red': <Translation id="red" defaultMessage="Red" />,
    'yellow': <Translation id="yellow" defaultMessage="Yellow" />,
    //NEW TYPES
    'BASIN': <Translation id="BASIN" defaultMessage="Bathroom basin" />,
    'VANITY': <Translation id="VANITY" defaultMessage="Washbasin" />,
    'TILE': <Translation id="TILE" defaultMessage="Tile" />,
    'SLAB': <Translation id="SLAB" defaultMessage="Slab" />,
    'SINK': <Translation id="SINK" defaultMessage="Kitchen sink" />,
    'STRAY': <Translation id="STRAY" defaultMessage="Shower tray" />,
    'CLAD': <Translation id="CLAD" defaultMessage="Cladding" />,
    'FLOOR': <Translation id="FLOOR" defaultMessage="Flooring" />,
    'CLAD_FLOOR': <Translation id="CLAD_FLOOR" defaultMessage="Flooring and cladding" />,
    'ELAB': <Translation id="ELAB" defaultMessage="Elaborated" />,
    'PAN': <Translation id="PAN" defaultMessage="Panel" />,
    'PANEL RANURADO': <Translation id="PANEL_RANURADO" defaultMessage="Slatwall panel" />,
    'KIT': <Translation id="KIT" defaultMessage="Kit" />,
    'ACC': <Translation id="ACC" defaultMessage="Accessory" />,
    'C_M': <Translation id="C_M" defaultMessage="Cleaning and maintenance" />,
    'TOOL': <Translation id="TOOL" defaultMessage="Tool" />,
    'AD': <Translation id="AD" defaultMessage="Adhesive" />,
    'SIL': <Translation id="SIL" defaultMessage="Silicone" />,
    'T&R': <Translation id="T&R" defaultMessage="Treatment and repair" />,
    'SINKS': <Translation id="sinks" defaultMessage="Sinks" />,
    'STRAYS': <Translation id="strays" defaultMessage="Strays" />,
})
